import { useMemo } from "react";
import PdfStyledTable from "../../pdfBuilder/components/data/PdfStyledTable";
// Assuming these helpers and PDF components already exist in your codebase:
// import { formatDollar, formatPhone } from "path/to/formatters";
// import PdfPageBrandedSubmission from "path/to/PdfPageBrandedSubmission";
// import { PdfSection, PdfSectionTitle, PdfBuilderDataItemRow } from "path/to/PdfComponents";

const DEFAULT_LENDER_ADDRESS =
  "ISAOA/ATIMA 290 Post Road West, Suite 100 Westport, CT 06880";

const PdfFundingShieldTable = ({ data, title }) => {
  const columnDefs = useMemo(
    () => [
      { headerName: "Field", field: "fieldLabel" },
      { headerName: "Value", field: "value" },
    ],
    []
  );
  if (!data) return null;

  const mappedRowData = [
    { fieldLabel: "Loan No.", value: data.loanNumber || "" },
    {
      fieldLabel: "Lender Name and Address",
      value: data.lenderName
        ? `${data.lenderName}\n${data.lenderAddress || ""}`
        : data.lenderAddress || "",
    },
    {
      fieldLabel: "Borrower Type (Individual, Trust, or Entity)",
      value: data.borrowerType || "",
    },
    { fieldLabel: "Borrower Name", value: data.borrowerName || "" },
    {
      fieldLabel: "Borrower Trust/Entity Name",
      value: data.borrowerEntityName || "",
    },
    {
      fieldLabel: "Subject Property Address",
      value: data.subjectPropertyAddress || "",
    },
    { fieldLabel: "City", value: data.subjectPropertyCity || "" },
    { fieldLabel: "State", value: data.subjectPropertyState || "" },
    { fieldLabel: "Zip", value: data.subjectPropertyZip || "" },
    {
      fieldLabel: "Total Loan Amount",
      value: data.totalLoanAmountFormatted || data.totalLoanAmount || "",
    },
    {
      fieldLabel: "Account Manager Name",
      value: data.accountManagerName || "",
    },
    {
      fieldLabel: "Account Manager Email",
      value: data.accountManagerEmail || "",
    },
    {
      fieldLabel: "Account Manager Phone",
      value: data.accountManagerPhone || "",
    },
    { fieldLabel: "Correspondent", value: data.correspondentName || "" },
    {
      fieldLabel: "Correspondent POC Name",
      value: data.correspondentPOCName || "",
    },
    {
      fieldLabel: "Correspondent POC Email",
      value: data.correspondentPOCEmail || "",
    },
    {
      fieldLabel: "Closing Agent Point of Contact Name",
      value: data.closingAgentPOCName || "",
    },
    {
      fieldLabel: "Closing Agent Point of Contact Email Address",
      value: data.closingAgentPOCEmail || "",
    },
  ];

  return (
    <PdfStyledTable
      // title={title || "FS Sheet"}
      columnDefs={columnDefs}
      // rowData={mappedRowData}
      data={data}
    />
  );
};

export default PdfFundingShieldTable;
